import React from 'react';
import uuid from 'uuid/v1';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Field, FieldArray, reduxForm } from 'redux-form';

import { CATEGORIES } from 'pages/create-activity/constants';

import HelpIcon from '@material-ui/icons/Help';

import {
  CurrencyInputWrapper,
  DropDown,
  ExpansionPanelWrapper,
  FormActionButtons,
  PopoverWrapper
} from 'components';

import validate from './validate';

import { useStyles } from './styles';
import FormHelperText from '@material-ui/core/FormHelperText';

const initialValues = {
  categories: [
    {
      id: uuid(),
      participant: 'Adult',
      USD: '0',
      EUR: '0',
      NOK: '0'
    }
  ]
};

const PricesCategorySection = ({
  handleSubmit,
  pricesCategoryForm,
  setSubmitButton,
  isUpdate
}) => {
  const classes = useStyles();
  const [t] = useTranslation();

  const onAddHandler = (fields, id) => {
    fields.push({
      id: id,
      participant: '',
      USD: '0',
      EUR: '0',
      NOK: '0'
    });
  };

  const getAvailableCategoriesNames = () => {
    const categories = pricesCategoryForm.values.categories.map(
      item => item.participant
    );
    return CATEGORIES.filter(x => !categories.includes(x));
  };

  const getParticipantList = index => {
    const participant = pricesCategoryForm.values.categories[index].participant;
    if (participant) return [participant, ...getAvailableCategoriesNames()];
    return getAvailableCategoriesNames();
  };

  return (
    <div className={classes.wrapper}>
      <form onSubmit={handleSubmit}>
        <FieldArray
          name="categories"
          component={ExpansionPanelWrapper}
          disabledItemIndex={0}
          isAddDeleteActions={true}
          add={onAddHandler}
          getTitle={item => item.participant}
          tabName="price"
          tabNameAll="all prices"
          children={(field, index, meta) => (
            <div className={classes.categoriesWrapper}>
              <Field
                name={`${field}.participant`}
                className={classes.dropDownField}
                list={getParticipantList(index)}
                label="Category"
                component={DropDown}
              />
              <div className={classes.row}>
                <Field
                  name={`${field}.NOK`}
                  label="NOK"
                  isHiddenErrorMsg={true}
                  className={classes.currencyField}
                  component={CurrencyInputWrapper}
                />
                <Field
                  name={`${field}.EUR`}
                  label="EUR"
                  isHiddenErrorMsg={true}
                  className={classes.currencyField}
                  component={CurrencyInputWrapper}
                />
                <Field
                  name={`${field}.USD`}
                  label="USD"
                  isHiddenErrorMsg={true}
                  className={classes.currencyField}
                  component={CurrencyInputWrapper}
                />
                <PopoverWrapper text="Value for at least one currency for each category should be filled in. Currencies marked with zero (or empty) will not be displayed on the widget.">
                  <HelpIcon className={classes.helpIcon} />
                </PopoverWrapper>
              </div>
              {meta.submitFailed && meta.error && meta.error[index] && (
                <FormHelperText error>{t(meta.error[index])}</FormHelperText>
              )}
            </div>
          )}
        />
        <FormActionButtons
          cancelPath="/accommodations-and-activities"
          actionLabel="Next"
          setSubmitButton={setSubmitButton}
          isUpdate={isUpdate}
        />
      </form>
    </div>
  );
};

const mapStateToProps = state => ({
  pricesCategoryForm: state.form.pricesCategoryForm
});

export default reduxForm({
  form: 'pricesCategoryForm',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: false,
  touchOnBlur: false,
  validate,
  initialValues
})(connect(mapStateToProps, null)(PricesCategorySection));
